import { v3Url } from '@/utils/fetcher';
import useListLoader from '../base/useListLoader';

function responseToMeta({
  data: {
    taskCompletions: { users, ...completions },
  },
}) {
  return { completions };
}

function responseToItems({
  data: {
    taskCompletions: { users: completionItems = [] },
    included: { users = {} } = {},
  },
}) {
  return completionItems.map((taskCompletion) => {
    const userId = taskCompletion.userId;
    const user = users[userId] || { userId };

    const formattedUserData = {
      ...user,
      activeProjects: taskCompletion.activeProjects,
      assignedTasks: taskCompletion.assignedTasks,
      completedTasks: taskCompletion.completedTasks,
      overdueTasks: taskCompletion.overdueTasks,
    };

    return formattedUserData;
  });
}

export default function useReportsTasksCompletionLoader({ params, count, pageSize } = {}) {
  const { state } = useListLoader({
    url: v3Url('reporting/precanned/usertaskcompletion'),
    params,
    count,
    pageSize,
    responseToItems,
    responseToMeta,
  });

  return state;
}
